import { z } from 'zod';

export function fixGoDate(date: Date, dateString: string | null | undefined): Date | null {
  if (dateString == null || dateString.startsWith('0001')) {
    return null;
  }

  return date;
}

export function fixGoSlice<T>(slice: T[] | null): T[] {
  if (slice === null) {
    return [];
  }

  return slice;
}

// Zod ports of the fixups above, for schemas migrated off Yup.

// ISO date string → Date. Only strings are coerced (z.coerce.date would turn
// null into the 1970 epoch); Date instances pass through, everything else is
// rejected by z.date().
export const zGoDate = z.preprocess(
  (value) => (typeof value === 'string' ? new Date(value) : value),
  z.date()
);

// Nullable Go date: Go marshals the zero time.Time as "0001-01-01T00:00:00Z";
// treat it — and null/absent — as null, like fixGoDate.
export const zGoNullableDate = z.preprocess(
  (value) =>
    value == null || (typeof value === 'string' && value.startsWith('0001')) ? null : value,
  z.preprocess(
    (value) => (typeof value === 'string' ? new Date(value) : value),
    z.date().nullable()
  )
);

// Go marshals a nil slice as null; treat it as the empty array, like fixGoSlice.
export function zGoSlice<T extends z.ZodType>(element: T) {
  return z.preprocess((value) => value ?? [], z.array(element));
}
